import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  notificationDetails: null,
  error: null,
  count: 0,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    fetchNotificationStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchNotificationSuccess(state, action) {
      state.isLoading = false;
      state.notificationDetails = action.payload;
      state.error = null;
      state.count = action.payload?.result?.count;
    },
    fetchNotificationFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchNotificationStart,
  fetchNotificationSuccess,
  fetchNotificationFailure,
} = notificationSlice.actions;

export default notificationSlice.reducer;